module.exports = __webpack_public_path__ + "img/upper_arm.7ff23001.png";